import React from 'react';
import { Facebook, Instagram, MapPin, Phone } from 'lucide-react';
import { BUSINESS, NAV_LINKS } from './data';
export function Footer() {
  return <footer className="w-full bg-brand-ink text-white" data-id="element-56" data-mp="3adlux4kg34mq">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8" data-id="element-57" data-mp="2wgyxz1shsegt">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3" data-id="element-58" data-mp="31erzvimrimba">
          <div data-id="element-59" data-mp="31h4g9rcvgom8">
            <img src={BUSINESS.logoWhite} alt={BUSINESS.name} className="h-12 w-auto" data-id="element-60" data-mp="31guyus5w7ps5" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/70" data-id="element-61" data-mp="3p6pa55akd6aa">
              Professional turf, pavers, and landscaping for residential and commercial
              properties across Arizona.
            </p>
            <div className="mt-5 flex gap-3" data-id="element-62" data-mp="3kdmij2pck6wq">
              <a href={BUSINESS.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 transition-colors hover:bg-brand-red hover:border-brand-red" data-id="element-63" data-mp="3kcbcsxcccp2z">
                <Facebook className="h-5 w-5" data-id="element-64" data-mp="3egroy0swzlh6" />
              </a>
              <a href={BUSINESS.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 transition-colors hover:bg-brand-red hover:border-brand-red" data-id="element-65" data-mp="3eeewgtpj5spv">
                <Instagram className="h-5 w-5" data-id="element-66" data-mp="12eilagvce2h" />
              </a>
            </div>
          </div>

          <div data-id="element-67" data-mp="f1o0cekq3g8k">
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-white/90" data-id="element-68" data-mp="f0366q2blzb8">
              Explore
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-69" data-mp="axyf9z39bgsa">
              {NAV_LINKS.map(link => <li key={link.href} data-id="element-70" data-mp="2guu1dozogpyd">
                  <a href={link.href} className="text-sm text-white/70 transition-colors hover:text-white" data-id="element-71" data-mp="2crnuqg8nkwrd">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-72" data-mp="kqe6kan1b3xr">
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-white/90" data-id="element-73" data-mp="kpuxljfd3pvv">
              Contact
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-white/70" data-id="element-74" data-mp="unir6618ercg">
              <li data-id="element-75" data-mp="ulpmgwa6ih73">
                <a href={BUSINESS.phoneHref} className="flex items-center gap-2.5 hover:text-white" data-id="element-76" data-mp="ypdtnduwfart">
                  <Phone className="h-4 w-4 text-brand-red" data-id="element-77" data-mp="13o793btqxbum" />
                  {BUSINESS.phoneDisplay}
                </a>
              </li>
              <li data-id="element-78" data-mp="18gi9efseeznp">
                <a href={BUSINESS.maps} target="_blank" rel="noreferrer" className="flex items-start gap-2.5 hover:text-white" data-id="element-79" data-mp="18fz0tpon1nmc">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" data-id="element-80" data-mp="1ibjwl6345rnn" />
                  {BUSINESS.region}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/50 sm:flex-row" data-id="element-81" data-mp="36uo3ns21wwi8">
          <p data-id="element-82" data-mp="2xvj8mvpp7lat">© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p data-id="element-83" data-mp="2sxrfjydbht51">Licensed & insured · Arizona</p>
        </div>
      </div>
    </footer>;
}